import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useEffect, useState } from "react";

const API_URL = `${process.env.REACT_APP_API_URL}/captcha`;

const getCaptcha = async (): Promise<Blob> => {
  const response = await axios.get(API_URL, {
    responseType: "blob",
    withCredentials: true,
  });
  return response.data;
};

export function useCaptcha(enabled: boolean = true) {
  const [captchaUrl, setCaptchaUrl] = useState<string | null>(null);

  const captchaQuery = useQuery<Blob, Error>({
    queryKey: ["captcha"],
    queryFn: getCaptcha,
    enabled,
    staleTime: 0,
  });

  useEffect(() => {
    if (!captchaQuery.data) return;

    const url = URL.createObjectURL(captchaQuery.data);
    setCaptchaUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [captchaQuery.data]);

  return {
    captchaQuery,
    captchaUrl,
    refreshCaptcha: captchaQuery.refetch,
  };
}